module.exports = __webpack_public_path__ + "static/img/goal.5f243e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/matchInfo/goal.svg
// module id = FlER
// module chunks = 1